import React, { useEffect, useState } from 'react';
import styles from '../TripTrackingV2.module.scss';

const EnterIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M8 3H5a2 2 0 0 0-2 2v3M16 3h3a2 2 0 0 1 2 2v3M21 16v3a2 2 0 0 1-2 2h-3M8 21H5a2 2 0 0 1-2-2v-3" />
  </svg>
);

const ExitIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 3v3a2 2 0 0 1-2 2H4M15 3v3a2 2 0 0 0 2 2h3M4 15h3a2 2 0 0 1 2 2v3M20 15h-3a2 2 0 0 0-2 2v3" />
  </svg>
);

// Replaces Google Maps' own fullscreen control (disabled in TripMap), which
// only fullscreens the map's inner div and drops the layers drawer sitting
// as its sibling - this fullscreens the whole map wrapper instead.
const FullscreenButton = ({ targetRef }) => {
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    const onChange = () => setIsFullscreen(!!document.fullscreenElement);
    document.addEventListener('fullscreenchange', onChange);
    return () => document.removeEventListener('fullscreenchange', onChange);
  }, []);

  const toggleFullscreen = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen();
    } else if (targetRef.current) {
      targetRef.current.requestFullscreen();
    }
  };

  return (
    <button type="button" className={styles.fullscreenButton} onClick={toggleFullscreen}>
      {isFullscreen ? <ExitIcon /> : <EnterIcon />}
    </button>
  );
};

export default FullscreenButton;
